import { render, staticRenderFns } from "./InsightMetric.vue?vue&type=template&id=3ead89c0&scoped=true&"
import script from "./InsightMetric.vue?vue&type=script&lang=js&"
export * from "./InsightMetric.vue?vue&type=script&lang=js&"
import style0 from "./InsightMetric.vue?vue&type=style&index=0&id=3ead89c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ead89c0",
  null
  
)

export default component.exports